<span class="guarantee-requests-title" translate>last.guarantee.requests</span>
<ng-container *ngIf="!isLoading else loading">
	<div class="guarantee-block-item" *ngFor="let guarantee of guaranteeRequests">
		<div class="guarantee-requests-identity">
			<div>
				<div class="guarantee-requests-subtitle">{{guarantee.name}}</div>
				<div class="guarantee-requests-date">{{guarantee.requestDate ? (guarantee.requestDate | copoDate:'date') : ''}}</div>
			</div>
			<div class="pill guarantee-requests-status" [class.request-status-bg-draft]="isDraft(guarantee)"
				[class.request-status-bg-open]="isOpen(guarantee)"
				[class.request-status-bg-other]="isOther(guarantee)"
				[class.request-status-bg-satisfied]="isSatisfied(guarantee)"
				[class.request-status-bg-certificate-requested]="isCertificateRequested(guarantee)"
				[class.request-status-bg-certificate-issued]="isCertificateIssued(guarantee)"
				[class.request-status-bg-rejected]="isRejected(guarantee)"
				[class.request-status-bg-cancelled]="isCancelled(guarantee)"
				[class.request-status-bg-unknown]="isUnknown(guarantee)">
				{{getGuaranteeRequestStatus(guarantee.status)}}
			</div>
			<button type="button" mat-mini-fab color="link" class="view-request-icon" [routerLink]="['/guarantee-requests/card/', guarantee.id]" [title]="'quapp.action.view' | translate">
				<mat-icon svgIcon="md:eye" color="accent"></mat-icon>
			</button>
		</div>
	</div>
	<div class="guarantee-request-list-view-details">
		<a mat-button class="guarantee-requests-footer" [routerLink]="['/guarantee-requests/list']">
			<span class="guarantee-requests-footer-label" translate>quality.feedback.card.details</span>
			<mat-icon iconPositionEnd svgIcon="md:chevron_right" color="accent"></mat-icon>
		</a>
	</div>
</ng-container>
<ng-template #loading>
	<copo-loading-spinner></copo-loading-spinner>
</ng-template>